import React from "react";

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import parse from 'html-react-parser';
import AppTheme from "../../../shared/utils/Theme";

interface HTMLDisplayProps {
    html: string;
}

const HTMLDisplay = (props: HTMLDisplayProps) => {
    const { html } = props;
    return <iframe
      title="HTML preview"
      srcDoc={html}
      style={{ width: "100%", height: window.innerHeight - 100, border: 0, alignItems:"center" }}
      sandbox="allow-same-origin"
    />
    console.log(html);
    const htmlToDisplauy = ReactHtmlParser(html);
    console.log({htmlToDisplauy});
    return parse(html);
}

export default HTMLDisplay;